import { render, staticRenderFns } from "./MailLogs.vue?vue&type=template&id=050b1456&"
import script from "./MailLogs.vue?vue&type=script&lang=js&"
export * from "./MailLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports